import { Link } from "react-router-dom"
import { ChevronRight, Home } from "lucide-react"
import { cn } from "@/lib/utils"

interface BreadcrumbItem {
  label: string
  href?: string
  icon?: React.ComponentType<{ className?: string }>
}

interface BreadcrumbProps {
  items: BreadcrumbItem[]
  className?: string
}

function Breadcrumb({ items, className }: BreadcrumbProps) {
  return (
    <nav aria-label="Breadcrumb" className={cn("flex items-center gap-1", className)}>
      <Link
        to="/"
        className="rounded-md p-1 text-muted-foreground/60 hover:text-primary hover:bg-primary/5 transition-colors"
        aria-label="Home"
      >
        <Home className="h-3.5 w-3.5" />
      </Link>
      {items.map((item, i) => {
        const Icon = item.icon
        const isLast = i === items.length - 1
        return (
          <span key={item.label} className="flex items-center gap-1">
            <ChevronRight className="h-3 w-3 text-muted-foreground/30 flex-shrink-0" />
            {item.href && !isLast ? (
              <Link
                to={item.href}
                className="rounded px-1.5 py-0.5 text-[11px] font-medium text-muted-foreground/60 hover:text-primary hover:bg-primary/5 transition-colors"
              >
                {Icon && <Icon className="h-3 w-3 inline-block mr-1 -mt-px" />}
                {item.label}
              </Link>
            ) : (
              <span className="flex items-center gap-1 px-1.5 py-0.5 text-[11px] font-semibold text-foreground/80">
                {Icon && <Icon className="h-3 w-3" />}
                {item.label}
              </span>
            )}
          </span>
        )
      })}
    </nav>
  )
}

export { Breadcrumb }
